import { createSlice } from '@reduxjs/toolkit';

const toursSlice = createSlice({
  name: 'tours',
  initialState: {
    toursData: {},
    toursDataIsLoading: false,
    toursDataErrorMsg: null,
  },
  reducers: {
    toursReq: (state, action) => { },
    toursSuccess: (state, action) => ({
      ...state,
      toursData: action.payload,
      toursDataIsLoading: false,
      toursDataErrorMsg: null,
    }),
    toursFailure: (state, action) => ({
      ...state,
      toursDataIsLoading: false,
      toursDataErrorMsg: action.payload,
    }),
    toursLoading: (state) => ({
      ...state,
      toursDataIsLoading: true,
      toursDataErrorMsg: null,
    }),
    toursClear: (state) => ({
      ...state,
      toursData: {},
      toursDataIsLoading: false,
      toursDataErrorMsg: null,
    }),
  },
});

export const {
  toursClear,
  toursFailure,
  toursLoading,
  toursReq,
  toursSuccess,
} = toursSlice.actions;

export default toursSlice.reducer;
